{
  "appName": "Hylo",
  "projectExternal": "外部",
  "projectDashboardCount": "Dashboard {{count}}",
  "projectDashboardLabel": "{{count}} 个 Dashboard",
  "conversationNames": { "notes": "笔记", "group": "群组", "direct": "私聊", "deleted": "已注销的账号", "unknown": "未知" },
  "ok": "好",
  "cancel": "取消",
  "done": "完成",
  "close": "关闭",
  "save": "保存",
  "edit": "编辑",
  "delete": "删除",
  "retry": "重试",
  "back": "返回",
  "search": "搜索",
  "loading": "正在载入…",
  "unsupportedContent": "此消息需要更新版本的 Hylo。"
}
